import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Wand2, ShoppingBag, FlipHorizontal2 } from "lucide-react";
import { api, resolveImg, track } from "@/lib/api";

export default function FeaturedOn({ print, accent = "#00E5FF", name }) {
  const [personas, setPersonas] = useState([]);
  const [view, setView] = useState("front");
  useEffect(() => {
    api.get("/studio/personas").then((r) => setPersonas(r.data)).catch(() => {});
  }, []);

  if (!print || personas.length === 0) return null;
  const isBack = view === "back";

  return (
    <section className="mt-16" data-testid="featured-on">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
        <div>
          <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] text-cyan/70">
            <Users className="w-3.5 h-3.5" /> FEATURED ON
          </div>
          <h2 className="font-head text-2xl font-bold uppercase mt-1">
            {name} worn across the <span style={{ color: accent }}>Aether collective</span>
          </h2>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex gap-1.5" data-testid="featured-view-toggle">
            {["front", "back"].map((v) => (
              <button key={v} onClick={() => setView(v)} data-testid={`featured-view-${v}`}
                className={`font-mono text-[9px] tracking-widest px-3 py-2 border transition-all ${
                  view === v ? "border-cyan text-cyan box-glow-cyan" : "border-white/15 text-slate-400 hover:border-cyan/50"
                }`}>
                <FlipHorizontal2 className="inline w-3 h-3 mr-1" />{v.toUpperCase()}
              </button>
            ))}
          </div>
          <Link to="/studio" data-testid="featured-design-cta"
            className="btn-hud flex items-center gap-2 border border-amber/40 text-amber px-4 py-2 text-xs hover:bg-amber hover:text-app">
            <Wand2 className="w-4 h-4" /> Put your art on these
          </Link>
        </div>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-4 snap-x scrollbar-thin" data-testid="featured-carousel">
        {personas.map((p) => {
          const showBack = isBack && p.back_image;
          return (
            <div key={p.id} data-testid={`featured-${p.id}`}
              className="group relative shrink-0 w-44 aspect-[2/3] snap-start border border-white/10 hover:border-cyan/50 transition-colors overflow-hidden bg-app">
              <img src={showBack ? p.back_image : resolveImg(p.image)} alt={p.title} loading="lazy"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
              <img src={resolveImg(print)} alt="" draggable={false}
                style={{ position: "absolute", left: "50%", top: showBack ? "28%" : "32%", width: showBack ? "30%" : "32%", transform: "translate(-50%, -50%)", filter: `drop-shadow(0 0 7px ${accent}) drop-shadow(0 1px 2px rgba(0,0,0,0.6))` }} />
              <Link to={`/studio?print=${encodeURIComponent(print)}&name=${encodeURIComponent((name || "Featured") + " Print")}`}
                data-testid={`shop-look-${p.id}`}
                onClick={() => track("shop_look_tap", { persona_id: p.id })}
                className="absolute top-2 left-1/2 -translate-x-1/2 z-10 opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1.5 bg-app/85 border border-cyan text-cyan px-3 py-1.5 font-mono text-[9px] tracking-widest hover:bg-cyan hover:text-app whitespace-nowrap">
                <ShoppingBag className="w-3 h-3" /> SHOP THIS LOOK
              </Link>
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-app via-app/70 to-transparent p-2.5 pt-6 pointer-events-none">
                <div className="font-mono text-[9px] tracking-widest" style={{ color: p.accent }}>{p.title}{showBack && " · BACK"}</div>
                <div className="font-body text-xs text-slate-300">{p.name}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
